import React, { useState } from 'react';
import axios from 'axios';
import { servicios_grupogack_org, cambios_no_guardados } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService';
import ModalService from '../../../ModalService/ModalService';
import AlertForm from '../../../../../../Services/AlertForm';
import FormTurnos from './FormTurnos';
import { JsonTurnosAdd } from '../../../Helpers/JsonToOneLevel';

const ModalEditTurnos = ({ openEdit, setOpenEdit, elementSelect, editar, errorTable, nombreModulo }) => {
    const [ error, setError ] = useState( null );
    const cerrarModal = () => {
        setOpenEdit( false );
        setError( null );
    }

    const actualizarTurno = turno => {
        axios.put(`${servicios_grupogack_org}/turno/`, turno, headersAuth())
        .then(res => {
            switch(res.data.status) {
                case 200:
                    editar(JsonTurnosAdd(res.data.dataResponse[0]));
                    setOpenEdit( false );
                    break;
                case 404:
                    setError( <AlertForm message={ res.data.msg } /> );
                    break;
                default:
                    errorTable(cambios_no_guardados);
                    break;
            }
        })
        .catch(error => console.log(error));        
    }

    return (
        <ModalService title="Actualizar Turno" parentNode={nombreModulo} minWidth="40%"
            isOpen={ openEdit } onClose={ () => cerrarModal() } >
                <FormTurnos
                    error={error}
                    elementSelect={elementSelect}
                    actualizarTurno={actualizarTurno}
                />
        </ModalService>
    );
};

export default ModalEditTurnos;